<template>
  <div class="poster-cont">
    <div class="poster-form">
      <input
        class="poster-input-styl"
        v-model="phone"
        type="number"
        placeholder="请输入企业合伙人账号"
      />
      <div class="poster-tips" v-show="showTips">该账号尚未入驻! 请入驻后参与</div>
      <div class="poster-get-btn" @click="handleGetPoster">获取专属海报</div>
      <div class="poster-jion-btn" @click="partnerInResidence">尚未入驻 申请成为企业合伙人</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "poster",
  data() {
    return {
      phone: '',
      showTips: false
    }
  },
  methods: {
    async handleGetPoster() {
      if (!this.phone) {
        this.$toast('请输入企业合伙人账号')
        return
      }
      let params = {phone:this.phone}
      let res = await this.$api.grouppurchase.findBranchIdByPhone(params);
      if (res.data && res.data !=null) {
        this.$toast('申领成功 即将生成专属海报');
        setTimeout(() => {
          this.$router.push({
            path: '/grouppurchase/swipePoster?branchId='+res.data
          })
        },300)
      } else {
        this.showTips = true;
      }
    },
    partnerInResidence() {
      let envArr = ['testing1', 'testing2', 'testing3', 'fat', 'uat'];
      let env = window.location.port ? 'testing3' : '';
      envArr.forEach(d => {
        if (location.hostname.includes(d)) {env = d}
      })
      let url = env ? `https://c-h5.${env}.wdeduc.com/cityPartnerInvitation` : 'https://c-h5.wdecloud.com/cityPartnerInvitation'
      window.open(url)
    }
  }
}
</script>

<style lang="stylus" scoped>
 @import "../asset/css/poster.styl" 
</style>